import { Container, Grid2 as Grid, Skeleton, Box } from '@mui/material';

export default function SemiMonthlySummaryPageSkeleton() {
  return (
    <Container maxWidth="xl" sx={{ my: 4 }}>
      <Grid container spacing={3} sx={{ mt: 2, mb: 4 }}>
        <Grid size={{ xs: 12 }}>
          <Box component="header">
            <Grid container spacing={2} alignItems="center">
              <Grid size={{ xs: 12 }}>
                <Skeleton variant="text" width={350} height={48} />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Skeleton variant="text" width="80%" height={24} />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Box component="main">
            <Grid container spacing={3}>
              <Grid size={{ xs: 12 }} container justifyContent="space-between">
                <Grid size={{ xs: 12, md: 4 }}>
                  <Skeleton variant="rounded" width="100%" height={56} />
                </Grid>

                <Grid size={{ xs: 12, md: 'auto' }}>
                  <Skeleton variant="rounded" width={200} height={56} />
                </Grid>

                <Grid
                  container
                  size={{ xs: 12 }}
                  spacing={2}
                  justifyContent="space-between"
                >
                  <Grid size={{ xs: 12 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                        <Skeleton variant="rounded" width="100%" height={200} />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                        <Skeleton variant="rounded" width="100%" height={200} />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                        <Skeleton variant="rounded" width="100%" height={200} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
